export enum KeycloakRoleEnum {
    ADMIN = 'admin',
    CUSTOMER = 'customer',
}
